import React from 'react'

/* eslint-disable import/no-cycle */
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import Checkbox from 'components/checkbox/checkbox'
import IconButton from 'components/icon-button'
import { IconNames } from 'components/icons'
import { isMobile } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'
import { mapMediaType } from 'selectors/mediaType'

import { CollapsibleInfoWrapper, HeaderContainer, Content } from './styles'

const MoreInfoIcon = ({ handleClick }) => (
  <IconButton
    name={IconNames.HelpCircle}
    color={({ theme }) => theme.colors.blue}
    size={16}
    onClick={() => handleClick(isExpanded => !isExpanded)}
  />
)

const CollapsibleInfo = props => {
  const [isExpanded, setExpanded] = React.useState(false)

  const { t } = useTranslation(NAMESPACES.CORPORATE_AGREEMENTS)

  const mobile = isMobile(props.mediaType)

  return (
    <CollapsibleInfoWrapper>
      <HeaderContainer>
        <Checkbox {...props} checkAlignTop={mobile}>
          <label dangerouslySetInnerHTML={{ __html: t('agreements.checkbox.accept-info') }} />
          {mobile && <br />}
          {mobile && <MoreInfoIcon handleClick={setExpanded} />}
        </Checkbox>
        {!mobile && <MoreInfoIcon handleClick={setExpanded} />}
      </HeaderContainer>
      {isExpanded && <Content>{t('agreements.collapsible.content')}</Content>}
    </CollapsibleInfoWrapper>
  )
}

CollapsibleInfo.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  checked: PropTypes.bool
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state)
})

export default connect(mapStateToProps)(CollapsibleInfo)
